import React, { useEffect, useState } from "react";
import classes from "./incident.module.scss";
import {
  getIncidentsReq,
} from "store/supervisor/actions";
import {
  makeSelectIncidents,
  makeSelectLoading,
} from "store/supervisor/selector";

import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import Table from "components/Supervisor/table";
import Button from "components/Supervisor/button";
import Pagination from "components/Supervisor/pagination";

import DeleteIcon from "assets/supervisorIcons/deleteIcon.js";
import PlusIcon from "assets/supervisorIcons/plusIcon.js";

import { delay } from "utils/helper";
import { useSortableData } from "utils/hooks";
import { isNil } from "lodash";

const Incident = ({
  incidents,
  getIncidents,
  loading,
  history,
}) => {
  const [selectedPage, setSelectedPage] = useState(1);
  const [searchState, setSearchState] = useState("");
  const [selectedRows, setSelectedRows] = useState([]);
  const [incidentList, setIncidentList] = useState([]);
  const [PAGE_COUNT, setPageCount] = useState(null);

  const [deleteModal, setDeleteModal] = useState({
    open: false,
    type: null,
    action: null,
    cancel: null,
  });
  const [mergeModal, setMergeModal] = useState({
    open: false,
    type: null,
    action: null,
    cancel: null,
  });

  const [incidentOptions, setIncidentOptions] = useState([]);

  const { requestSort, sortConfig } = useSortableData([]);
  const sortBy = (key) => {
    requestSort(key, (direction) =>
      getIncidents({
        page: selectedPage,
        search: searchState,
        ordering: direction === "descending" ? `-${key}` : key,
      })
    );
  };

  const orderingConfig =
    sortConfig?.direction?.toString() === "descending" &&
    !isNil(sortConfig?.key)
      ? `-${sortConfig.key}`
      : !isNil(sortConfig?.key)
      ? sortConfig?.key
      : "-id";

  useEffect(() => {
    getIncidents({ page: 1, search: "", ordering: "-id" });
  }, []);

  const handleKeyDown = (event) => {
    if (event.keyCode === 13) {
      setSelectedPage(1);
      getIncidents({
        search: event.target.value,
        page: 1,
        ordering: orderingConfig,
      });
    }
  };

  const rowActions = [
    {
      name: "Edit",
      action: (val) => history.push(`/supervisor-company-edit?id=${val.id}`),
    },
    {
      name: "Delete",
      action: (val) => {

      },
    },
  ];

  const incidentTableData = (item) => {
    const data = item.map((a) => {
      return {
        id: a.id,
        values: [
          {
            value: a.summary,
            id: a.id,
            raw: item,
          },
          {
            value: a.importance,
          },
          {
            value: a.person_affected,
          },
          {
            value: a.location,
          },
        ],
      };
    });

    const labels = [
      { label: "Summary", sortable: true, key: "summary" },
      { label: "Importance", sortable: true, key: "importance" },
      { label: "Person Affected", sortable: true, key: "person_affected" },
      { label: "Location", sortable: true, key: "location" },
    ];

    return {
      columns: data,
      labels: labels,
    };
  };

  useEffect(() => {

    if (incidents) {
      setIncidentList(incidentTableData(incidents.results));
      setPageCount(Number(incidents.items_per_page));

      const newRows = incidents.results.map((item, i) => {
        return {
          id: item.id,
          checked: false,
        };
      });
      setSelectedRows(newRows);
      const options = incidents.results.map((item) => {
        return {
          label: item.name,
          value: item.id,
        };
      });
      setIncidentOptions(options);
    }
  }, [incidents]);

  const onSearch = (e) => {
    setSearchState(e.target.value);
    setSelectedPage(1);
    if (e.target.value.length === 0) {
      getIncidents({ search: e.target.value, ordering: orderingConfig });
    }
  };

  return (
    <>
      <div className={classes.companyContainer}>
        <h1 className={classes.titleHead}>Incidents</h1>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            paddingRight: "20px",
          }}
        >
          {selectedRows &&
            selectedRows.filter((item) => item.checked).length > 0 && (
              <Button
                onClick={() => {
                }}
                icon={() => {
                  return <DeleteIcon />;
                }}
                text={"Delete"}
                color={"#E26C82"}
              />
            )}
          {selectedRows.filter((item) => item.checked).length === 2 && (
            <Button
              onClick={() => {

              }}
              icon={() => {
                return <PlusIcon />;
              }}
              text={"Merge"}
            />
          )}
          <Button
            width={"200px"}
            onClick={() => history.push("/supervisor-company-create")}
            icon={() => {
              return <PlusIcon />;
            }}
            text={"New Incident"}
          />
        </div>
        <div className={classes.companyContainer}>
          <Table
            width={"100%"}
            handleKeyDown={handleKeyDown}
            isSearchable={true}
            searchState={searchState}
            loading={loading}
            onSearch={(e) => onSearch(e)}
            selectedRows={selectedRows}
            setSelectedRows={setSelectedRows}
            data={incidentList}
            rowActions={rowActions}
            clickable={true}
            sortByDesc={(val) => sortBy(val)}
            sortConfig={sortConfig}
          />
        </div>
        <>
          {PAGE_COUNT && incidents && incidents.count > PAGE_COUNT && (
            <Pagination
              totalCount={incidents?.count}
              pageCount={PAGE_COUNT}
              currentPage={selectedPage}
              onChange={(val) => {
                getIncidents({
                  page: val + 1,
                  ordering: orderingConfig,
                  search: searchState,
                });
                setSelectedPage(val + 1);
              }}
            />
          )}
        </>
      </div>
    </>
  );
};

const mapStateToProps = createStructuredSelector({
  incidents: makeSelectIncidents(),
  loading: makeSelectLoading(),
});
const mapDispatchToProps = (dispatch) => {
  return {
    getIncidents: (val) => dispatch(getIncidentsReq(val)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Incident);
